import {
  createMatchClockHtmlFormatter,
  setMatchClock as setMatchClockWithLabels,
  setMobileMatchStatusClock as setMobileMatchStatusClockWithLabels,
} from "../../shared/date-time";

export const MATCH_STATUS_LABELS: Record<number, string> = {
  0: "B\u1ea5t th\u01b0\u1eddng",
  1: "Ch\u01b0a b\u1eaft \u0111\u1ea7u",
  3: "HT",
  5: "ET",
  6: "ET",
  7: "Lu\u00e2n l\u01b0u",
  8: "FT",
  9: "Tr\u00ec ho\u00e3n",
  10: "Gi\u00e1n \u0111o\u1ea1n",
  11: "\u0110\u00e3 h\u1ee7y",
  12: "\u0110\u00e3 h\u1ee7y",
  13: "Ch\u01b0a x\u00e1c \u0111\u1ecbnh",
};

export const formatMatchClockHtml =
  createMatchClockHtmlFormatter(MATCH_STATUS_LABELS);

export const setMatchClock = (
  root: ParentNode,
  selector: string,
  info: any,
) => {
  setMatchClockWithLabels(root, selector, info, MATCH_STATUS_LABELS);
};

export const setMobileMatchStatusClock = (root: ParentNode, info: any) => {
  setMobileMatchStatusClockWithLabels(root, info, MATCH_STATUS_LABELS);
};
